<template>
    <main-layout>
        <div class="container">
            <H1 class="pageTitle isPoppins">Manage Slinks</H1>
            
            <!-- <div class="left20 top60">
                <div class="handCursor mngTab" :class="{selectedOption : selected == 'slinks'}" @click="selectOption('s')">Slinks</div> 
                <div class="handCursor mngTab has-text-white" :class="{selectedOption: selected == 'packs'}" @click="selectOption('p')">Subpacks</div>
            </div> -->
           
         
            <div id="slinksTable" class="wideLimitWidth top40  accSettingsForm">
              
                <div v-if="selected == 'slinks'">
                      <div>
                          This is where you manage the slinks in your account. Click the MANAGE button on any one of them to assign a redirect URL or add subslinks.
                    </div>
                   <div class="has-text-right"> <button class="button is-dark" :class="{'is-yell': sortAlpha}" @click="toggleSort"><i class="fas fa-sort-alpha-down"></i></button></div>
                    <table class="bottom10" width="100%">
                        <tr class="top10 has-text-weight-bold" >
                            <td width="10%" class="has-text-warning">Slink</td>
                            <td width="20%" class="has-text-warning">Status</td>
                            <td width="20%" class="has-text-warning">Renews</td>
                            <td width="10%" class="has-text-warning"></td>
                            <td width="5%" class="has-text-warning"></td>
                        </tr>
                        <tr class="slctTableRow" v-for="(item, index) in slinksArr" :key="item.id" :class="{'tableDarkRow': ((index + 1) % 2)}">
                            <td class="has-text-weight-bold"><span class="has-text-turk">&raquo;</span><span class="left2">{{item.slink.toLowerCase()}}</span></td>
                            <td class="is-size-7">{{item.status | statusString}}</td>
                            <td class="is-size-7">{{genRenews(item.createDate, item.isTrial, item.code, item.slink)}}</td>
                            <td><button class="button is-small is-warning" @click="showDetail(item.slink)">MNG</button></td>
                            <td><button class="button is-small is-warning" :disabled="item.code == 'SmallMonthly' || item.code == 'SmallYearly'" @click="showAnalytics(item.slink)"><i class="fas fa-chart-bar is-size-5"></i></button></td>
                        </tr>
                    </table>
                </div>

               <!--  <div v-if="selected == 'packs'">
                    <div>This view shows all subslink packs that have become unassigned from their parent slink because their parent slink expired. If there is still time remaining in their subscription
                        period, they will be listed here so that you can assign them to another slink on your account.
                    </div>
                    <table class="bottom10" width="100%">
                        <tr class="top10 has-text-weight-bold" >
                            <td width="10%" class="has-text-warning">Subpack</td>
                            <td width="20%" class="has-text-warning">Status</td>
                            <td width="10%" class="has-text-warning">Renews</td>
                            <td width="10%">&nbsp;</td>
                        </tr>
                        <tr class="slctTableRow" v-for="(item, index) in packsArr" :key="item.id" :class="{'tableDarkRow': ((index + 1) % 2)}">
                            <td class="has-text-weight-bold"><span class="has-text-turk">&raquo;</span><span class="left2">Pack {{index + 1}}</span></td>
                            <td>{{item.status | statusString}}</td>
                            <td>{{az.dateConvertAddAYear(item.createDate)}}</td>
                            <td><button class="button is-small is-warning" @click="showSubDetail(item)">MANAGE</button></td>
                        </tr>
                    </table>
                </div> -->
            </div>
        </div>  
        <br> <br>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
import { AZEventBus } from '../components/AZEventBus'
export default {
  components: {
    MainLayout
  },
  data: function(){
      return {
          slinksArr: [],
          packsArr: [],
          az: az,
          selected: 'slinks',
          inited: false,
          sortAlpha: false
      }
  },
  mounted: function(){

   
    const self = this;
   
    function worked(data) {
      az.addRemSpinner(false, 'id', 'slinksTable');
     
      data.slinks.Items.sort(function (a, b) {
        return new Date(a.createDate) - new Date(b.createDate)
      })

       self.slinksArr = data.slinks.Items.filter(e => {
           e.date = new Date(e.createDate)
           return e.slink != 'slink'
       });

       self.slinksArr.sort((a,b) => {
           return b.date - a.date
       })

       document



       //self.packsArr = data.packs.Items
    }
    function noWorked() {
      az.addRemSpinner(false, 'id', 'slinksTable');
      self.$root.showModalOK({message: 'There was en error loading slinks list'})
    }


    function init(){
        self.inited = true
        az.addRemSpinner(true, 'id', 'slinksTable');
        setTimeout(function(){
           self.$root.apiClient.get('api/account/listslinks', {}, worked, noWorked)
        }, 200)
        
    }

    if(self.$root.doneFederating){
        init();
    }

    AZEventBus.$once('onFederate', msg => {
        if(self.inited == false)
            init();
    });
    
  },
  methods:{
    showDetail: function(slink){
        this.$router.push('/mngDetail?s=' + slink)
    },

    showSubDetail: function(sub){
        this.$router.push({name: 'mngsub', params: {sub: sub}})
    },

    selectOption: function(val){
        if(val == 's'){
            this.selected = 'slinks'
        } else if(val == 'p'){
            this.selected = 'packs'
        }
    },

    genRenews: function(val, isTrial, code, slink) {
      
       if(!isTrial)
          return az.dateCalc(val, code)
       else
          return 'Trial Expires: ' + az.dateConvertAdd30(val)
    },

    showAnalytics: function(slink) {
        this.$router.push('/metrics/' + slink)
    },

    toggleSort: function(){
        
        if(this.sortAlpha){
            this.sortAlpha = false
           
            this.slinksArr.sort((a,b) => {
                return b.date - a.date
            })
            
        } else {
            this.sortAlpha = true
            this.slinksArr.sort((a,b) => {
                var textA = a.slink
                var textB = b.slink
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            })
        }
    }
   }
}
</script>

<style  scoped>
    body{
        background-image: linear-gradient(45deg, #0a2540 75%,  #18a1d7) !important;
        background: -webkit-linear-gradient(45deg, #0a2540 75%,  #18a1d7) !important;
    }

    table tr{
        height: 3rem;
    }

    table tr td{
        padding-left: 2px;
        padding-right: 3px;
        vertical-align: middle
    }

    .button{
        vertical-align: middle;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Mng.vue